"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Subtitle = exports.SubtitleSection = exports.TitleIndicator = exports.Title = exports.TitleSection = exports.Item = exports.ItemGroup = void 0;

var _button = _interopRequireDefault(require("@clayui/button"));

var _icon = _interopRequireDefault(require("@clayui/icon"));

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _Context = _interopRequireDefault(require("./Context"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ItemGroup = function ItemGroup(_ref) {
  var children = _ref.children,
      className = _ref.className,
      otherProps = _objectWithoutProperties(_ref, ["children", "className"]);

  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: (0, _classnames.default)('modal-item-group', className)
  }, otherProps), children);
};

exports.ItemGroup = ItemGroup;

var Item = function Item(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      shrink = _ref2.shrink,
      otherProps = _objectWithoutProperties(_ref2, ["children", "className", "shrink"]);

  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: (0, _classnames.default)('modal-item', className, {
      'modal-item-shrink': shrink
    })
  }, otherProps), children);
};

exports.Item = Item;

var TitleSection = function TitleSection(_ref3) {
  var children = _ref3.children,
      className = _ref3.className,
      otherProps = _objectWithoutProperties(_ref3, ["children", "className"]);

  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: (0, _classnames.default)('modal-title-section', className)
  }, otherProps), children);
};

exports.TitleSection = TitleSection;

var Title = function Title(_ref4) {
  var children = _ref4.children,
      className = _ref4.className,
      otherProps = _objectWithoutProperties(_ref4, ["children", "className"]);

  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: (0, _classnames.default)('modal-title', className)
  }, otherProps), children);
};

exports.Title = Title;

var TitleIndicator = function TitleIndicator(_ref5) {
  var children = _ref5.children,
      className = _ref5.className,
      otherProps = _objectWithoutProperties(_ref5, ["children", "className"]);

  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: (0, _classnames.default)('modal-title-indicator', className)
  }, otherProps), children);
};

exports.TitleIndicator = TitleIndicator;

var SubtitleSection = function SubtitleSection(_ref6) {
  var children = _ref6.children,
      className = _ref6.className,
      otherProps = _objectWithoutProperties(_ref6, ["children", "className"]);

  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: (0, _classnames.default)('modal-subtitle-section', className)
  }, otherProps), children);
};

exports.SubtitleSection = SubtitleSection;

var Subtitle = function Subtitle(_ref7) {
  var children = _ref7.children,
      className = _ref7.className,
      otherProps = _objectWithoutProperties(_ref7, ["children", "className"]);

  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: (0, _classnames.default)('modal-subtitle', className)
  }, otherProps), children);
};

exports.Subtitle = Subtitle;
var ICON_MAP = {
  danger: 'exclamation-full',
  info: 'info-circle',
  success: 'check-circle-full',
  warning: 'warning-full'
};

var HighLevel = function HighLevel(_ref8) {
  var children = _ref8.children,
      onClose = _ref8.onClose,
      spritemap = _ref8.spritemap,
      status = _ref8.status;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Title, null, status && /*#__PURE__*/_react.default.createElement(TitleIndicator, null, /*#__PURE__*/_react.default.createElement(_icon.default, {
    spritemap: spritemap,
    symbol: ICON_MAP[status]
  })), children), /*#__PURE__*/_react.default.createElement(_button.default, {
    "aria-label": "close",
    className: "close",
    displayType: "unstyled",
    onClick: onClose
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    spritemap: spritemap,
    symbol: "times"
  })));
};

var ClayModalHeader = function ClayModalHeader(_ref9) {
  var children = _ref9.children,
      className = _ref9.className,
      otherProps = _objectWithoutProperties(_ref9, ["children", "className"]);

  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: (0, _classnames.default)('modal-header', className)
  }, otherProps), children);
};

var ClayModalHeaderHybrid = function ClayModalHeaderHybrid(_ref10) {
  var children = _ref10.children,
      _ref10$withTitle = _ref10.withTitle,
      withTitle = _ref10$withTitle === void 0 ? true : _ref10$withTitle,
      otherProps = _objectWithoutProperties(_ref10, ["children", "withTitle"]);

  var _React$useContext = _react.default.useContext(_Context.default),
      onClose = _React$useContext.onClose,
      spritemap = _React$useContext.spritemap,
      status = _React$useContext.status;

  return /*#__PURE__*/_react.default.createElement(ClayModalHeader, otherProps, withTitle && /*#__PURE__*/_react.default.createElement(HighLevel, {
    onClose: onClose,
    spritemap: spritemap,
    status: status
  }, children), !withTitle && children);
};

var _default = ClayModalHeaderHybrid;
exports.default = _default;